/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { BiSearch } from "react-icons/bi";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  UncontrolledTooltip,
  Modal,
  Spinner,
} from "reactstrap";

import schema from './filterValidation';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ExtraInputComponent } from "../../components/Common/FilterInput";
import BadgesEllipsis from "../../components/Common/BadgesEllipsis";
import {
  getAdditionalFields,
  resetAdditionalFields,
  resetError,
  activateAdditionalField,
} from "../../store/additionalFields/actions";
import {
  renderPagination,
} from "../../Libs/CrudUtils/crudUtils";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const AdditionalFields = ({ t }) => {
  const dispatch = useDispatch();
  
  const {
    dataAdditionalFields,
    loadingAdditionalFields,
    dataAdditionalFieldsEditCreate,
    errorAdditionalFields,
    successAdditionalFields,
  } = useSelector((state) => state.AdditionalFields);
  
  const [qtdDefault] = useState(7);
  const [page, setPage] = useState(1);
  const [modalActive, setModalActive] = useState(false);
  const [typeSearch, setTypeSearch] = useState(["name"]);
  const [fieldId, setFieldId] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [filterInput, setFilterInput] = useState("");
  const [filterType, setFilterType] = useState("");
  const [active, setActive] = useState("");
  const [status, setStatus] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(true);

  const [optionsInputSearch] = useState([
    {
      value: "name",
      label: t(`name`),
    },
    {
      value: "skill_name",
      label: t(`skillName`),
    },
  ]);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successAdditionalFields && dispatch(resetAdditionalFields()) && handleFilter(),
  };

  const {
    register,
    handleSubmit,
    errors,
    setValue,
    getValues,
    setError,
  } = useForm();

  const handleSubmitForm = useCallback( async (value) =>{
    try {
      await schema.validate(value);
    
      setPage(1);
      setFilterType(getValues('search_additional_fields.types')?.[0]);
      setFilterInput(getValues('search_additional_fields.value'));
      dispatch(getAdditionalFields( 
        page, 
        qtdDefault,
        getValues('search_additional_fields.value'),
        getValues('search_additional_fields.types')?.[0], 
      ));

      setTypeSearch(getValues('search_additional_fields.types'));

    } catch (error) {

      if(error?.message && error?.path){
        setError(`${error?.path}`, { type: 'custom', message: error?.message });
      }
    }    
  }, []);

  const handleFilter = useCallback(() => {
    dispatch(getAdditionalFields(1, qtdDefault, filterInput, filterType));
    setPage(1);
  }, [filterInput, filterType]);

  const handleActivate = () => {
    dispatch(activateAdditionalField(fieldId, active));
  };

  const handlePage = (value) => {
    setPage(value);
    const page = value;
    const qnt = qtdDefault;
    dispatch(getAdditionalFields(
      page,
      qnt,
      filterInput,
      filterType,
    ));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataAdditionalFields && dataAdditionalFields.paging) {
      if (page < dataAdditionalFields.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const setAdditionalFieldIdAndName = (field) => {
    setFieldId(field.id);
    setFieldName(field.name);
  };

  const toggleModalActive = () => {
    setModalActive((prev) => !prev);
  };

  useEffect(() => {
    if (errorAdditionalFields && typeof errorAdditionalFields === "object") {
      errorAdditionalFields.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "Additional Fields not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorAdditionalFields) {
        showToast("error", t(errorAdditionalFields));
        dispatch(resetError());
      }
    }
  }, [errorAdditionalFields]);

  // useEffect para ativar ou desativar o campo adicional
  useEffect(() => {
    if (dataAdditionalFieldsEditCreate && dataAdditionalFieldsEditCreate.message) {
      showToast("success", t(dataAdditionalFieldsEditCreate.message));
    }
  }, [dataAdditionalFieldsEditCreate]);

  useEffect(() => {
    setNotFound(dataAdditionalFields === null);
  }, [dataAdditionalFields]);

  useEffect(() => {
    dispatch(getAdditionalFields(page, qtdDefault, filterInput, filterType));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/additional-fields"
            title={t("Dashboard")}
            breadcrumbItem={t("Additional Fields")}
          />
          <Row>
            <Col xs="12">
              <Card style={{ backgroundColor: "#222736" }}>
                <CardBody className="card-height">
                  <form
                    className="content-filter"
                    onSubmit={handleSubmit(handleSubmitForm)}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" className="mb-3">
                        <ExtraInputComponent
                          labelDropdown={t("Search")}
                          name="search_additional_fields"
                          type="text"
                          placeholder={t("Enter the search term")}
                          options={optionsInputSearch}
                          register={register}
                          error={errors?.search_additional_fields}
                          typeInputRadio
                          buttonReset
                          reverteBordeButtonDrop
                          maxLength={60}
                          defaultValueTypes={
                            getValues("search_additional_fields.types")?.[0]
                              ? getValues("search_additional_fields.types")
                              : typeSearch
                          }
                          valueInput={nameFilter}
                          onChangeInput={(e) => {
                            setNameFilter(e?.target?.value);
                            setValue(
                              "search_additional_fields.value",
                              e?.target?.value
                            );
                          }}
                          onChangeSelect={(value) => {
                            setValue("search_additional_fields.types", value);
                          }}
                        />
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="d-flex align-items-center pt-0"
                      >
                        <div
                          className={
                            errors?.search_additional_fields ? "pb-3" : "pt-0"
                          }
                        >
                          <Button
                            type="submit"
                            color={"primary"}
                            // disabled={nameFilter?.length === 0}
                            className="waves-effect waves-light w-100 mb-3 mr-3"
                          >
                            <BiSearch size={18} />
                          </Button>
                        </div>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-Tab">
                          <Link to={`/additional-field`}>
                            <Button
                              type="button"
                              color="primary"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Additional Field")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </form>
                  <Row className="mb-4">
                    <Col xs="12">
                      <span>
                        {t(
                          "Editable fields created in each skill, only in text/number input format, will be shown in the widget “[widget name]” and the operator will be able to fill and edit whenever necessary, when the attendance is assigned to him."
                        )}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <div className="table-responsive">
                      <PerfectScrollbar>
                        <table className="table table-centered table-nowrap table-hover mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: "30%" }}>{t("Name")}</th>
                              <th style={{ width: "60%" }}>{t("Skills")}</th>
                              <th style={{ width: "7%" }}>{t("Status")}</th>
                              <th
                                style={{ width: "3%" }}
                                className="text-right pr-3"
                              >
                                {t("Action")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {loadingAdditionalFields
                              ? <tr>
                                <td colSpan="20" align="center">
                                  <Spinner
                                    size="sm"
                                    animation="border"
                                    style={{
                                      marginTop: "40px",
                                      height: "50px",
                                      width: "50px",
                                    }}
                                  />
                                </td>
                              </tr>
                              : notFound
                                ? <tr>
                                  <td colSpan="10" align="center">
                                    {t("Not found additional fields")}
                                  </td>
                                </tr>
                                : dataAdditionalFields?.data.map((field, index) => (
                                  <tr key={field.id}>
                                    <td style={{ width: "30%" }}>{field.name}</td>
                                    <td style={{ width: "60%" }}>
                                      {Array.isArray(field.additionalFieldsSkills) &&
                                        field.additionalFieldsSkills.length > 0 ? (
                                        <BadgesEllipsis
                                          objItems={field.additionalFieldsSkills}
                                          maxShowItems={4}
                                          colorItem="primary"
                                        />
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td>
                                      <div
                                        className="custom-control custom-switch"
                                        dir="ltr"
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id={"customSwitch" + field.id}
                                          readOnly
                                          checked={field.active}
                                          onClick={() => {
                                            setAdditionalFieldIdAndName(field);
                                            toggleModalActive();
                                            setStatus(
                                              field.active
                                                ? t("deactivate")
                                                : t("activate")
                                            );
                                            setActive(!field.active);
                                          }}
                                        />
                                        <label
                                          className="custom-control-label pointer"
                                          htmlFor={"customSwitch" + field.id}
                                        >
                                          {field.active
                                            ? t("Active")
                                            : t("Inactive")}
                                        </label>
                                      </div>
                                    </td>
                                    <td>
                                      <Link
                                        to={`/additional-field/${field.id}`}
                                        className="text-primary text-center"
                                        id="edit"
                                      >
                                        <i
                                          className="mdi mdi-pencil font-size-18 px-2"
                                          id={`edittooltip${index}`}
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target={`edittooltip${index}`}
                                        >
                                          {t("Edit")}
                                        </UncontrolledTooltip>
                                      </Link>
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </PerfectScrollbar>
                    {renderPagination(
                      page,
                      dataAdditionalFields?.paging,
                      handlePreviousPage,
                      handlePage,
                      handleNextPage
                    )}
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={modalActive}>
        <div className="modal-body font-size-18 text-center">
          {`${t("Do you want to")} ${status}`}
          <strong> {fieldName}</strong>?
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={toggleModalActive}
            className="btn btn-danger waves-effect"
            data-dismiss="modal"
            style={{ backgroundColor: "#f14646" }}
          >
            {t("No")}
          </button>
          <button
            type="button"
            className="btn btn-secondary waves-effect waves-light"
            onClick={() => {
              toggleModalActive();
              if (fieldId) handleActivate();
            }}
          >
            {t("Yes")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(AdditionalFields);
